module.exports = __webpack_public_path__ + "img/third-app-title.f5c5dd00.png";